require('./OKWizard.scss');

// @vendors
import React, { cloneElement, Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
import {
    addStep,
    removeStep,
    setCurrentStep,
    resetData,
    setWizardSuccess,
    setWizardError,
    validateGDPRAndOrOTP,
    setWizardButtonStateByButton,
    setWizardRestrictionError,
    validateLoading
} from 'actions/okWizard';

import { updateConsents } from 'actions/gdprConsents';

// @utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @components
import PreLeaveModalComponent from 'components/preLeaveModalComponent/preLeaveModalComponent';
import OKWizardProgressIndicator from './OKWizardProgressIndicator/OKWizardProgressIndicator.jsx';

// @common-components
import { OKButton } from 'commonsComponents/OKButton';

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
import { recordProcess, PROC_START, PROC_STEP, PROC_CANCEL } from 'utilities/tagging';
import { SOLIDARITY_CARD, ONG } from "constants/index";
const {
    MESSAGE_HIRE_24H
} = require('constants/flagBasedFeatures');

class OKWizard extends Component {
    constructor (props) {
        super(props);
        this.state = {
            link: null,
            showPreLeaveModal: false,
            exit: false
        }
    }

    componentDidMount () {
        const { processType, tealium, defaultRecordProcess } = this.props;

        if (defaultRecordProcess)
            recordProcess(processType, PROC_START, tealium);
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.otpError) {
            this.props.localSetWizardButtonStateByButton('submit', {
                loading: false,
                disabled: false
            });
        }
    }

    componentWillUnmount () {
        scrollToTop();

        this.setState({
            showPreLeaveModal: false
        });
    }

    handleSetAsCurrentStep = link => {
        this.setState({
            link
        });
    };

    closeModal() {
        this.setState({
            showPreLeaveModal: false
        });
    }

    goBackModal() {
        this.setState({
            exit: true
        }, this.props.goBackLink ? () => this.props.history.push(this.props.goBackLink) : this.props.history.goBack);
    }

    buildPreLeaveModal () {
        const { showPreLeaveModal, exit } = this.state;
        const {
            onPreLeaveModalReady,
            preleaveModalTitle,
            preleaveModalMessage,
            preleaveModalLeftButtonConfig,
            preleaveModalRightButtonConfig,
            onConfirmLeave
        } = this.props;

        let dataToRender = null;
        const isReady = onPreLeaveModalReady();
        if(exit || isReady) return dataToRender;

        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = preleaveModalTitle ? preleaveModalTitle : formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = preleaveModalMessage ? preleaveModalMessage : formatText('wizard-redirectConfirmationMessage');

        return (
            <PreLeaveModalComponent
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationTitle}
                acceptText={acceptText}
                cancelText={cancelText}
                isReady={onPreLeaveModalReady}
                leftButtonConfig={preleaveModalLeftButtonConfig}
                rightButtonConfig={preleaveModalRightButtonConfig}
                onConfirmLeave={() => Boolean(onConfirmLeave) && onConfirmLeave()}
                isOkNewWizard={showPreLeaveModal}
                closeModalNewWizard={() => this.closeModal()}
                cancelModalNewWizard={() => this.goBackModal()}
            />
        );
    }

    handleCancel = () => {
        const { processType, tealium, defaultRecordProcess, onPreLeaveModalReady, onConfirmLeave } = this.props;
        const isReady = onPreLeaveModalReady();

        if (defaultRecordProcess)
            recordProcess(processType, PROC_CANCEL, tealium);

        if (isReady) {
            onConfirmLeave && onConfirmLeave();
        } else {
            this.setState({
                showPreLeaveModal: true
            });
        }
    };

    handleGoBack = () => {
        alert('Go back!');
    };

    updateSteps = (result, currStep) =>{
        const {localAddStep, localSetCurrentStep} = this.props

        localAddStep(result, currStep);
        localSetCurrentStep(currStep + 1);
        scrollToTop();
    }

    // Beware of the async function!!! We need to await the step response
    // because we are using an asynchronous state.

    handleNext = async () => {
        const { currentStep, processType, tealium, type, defaultRecordProcess, localSetWizardRestrictionError, setHireMessage, hireRestrictionFF, validateLoading } = this.props;
        const result = await this.state.link();

        if (defaultRecordProcess) recordProcess(processType, PROC_STEP, tealium);

        if(currentStep === 0 && hireRestrictionFF && type === SOLIDARITY_CARD && setHireMessage) {
            setHireMessage(validateLoading, (step) => this.updateSteps(result, step),localSetWizardRestrictionError);
        }
        else
        {
            this.updateSteps(result, currentStep)
        }
    };

    handlePrevious = () => {
        const { localRemoveStep, localSetCurrentStep, currentStep, validateLoading } = this.props;
        localRemoveStep(currentStep);
        localSetCurrentStep(currentStep - 1);
    };

    handleSubmit = () => {
        const {
            localValidateGDPRAndOrOTP,
            localSetWizardSuccess,
            localSetWizardError,
            submitResults,
            localSetWizardButtonStateByButton
        } = this.props;

        const result = this.state.link();

        const getDataToken = (dispatch, getState, dataToken) => {
            submitResults(localSetWizardSuccess, localSetWizardError, dataToken, getState);
            dispatch(updateConsents(dataToken));
        };

        if (result.isValid) {
            localSetWizardButtonStateByButton('submit', {
                loading: true,
                disabled: false
            });
            localValidateGDPRAndOrOTP(getDataToken);
        }
    };

    render() {
        const {
            currentStep,
            steps,
            fullWidth,
            children,
            wizardSideContent,
            goBackButtonStatus,
            cancelButtonStatus,
            previousButtonStatus,
            nextButtonStatus,
            submitButtonStatus,
            validateLoadingFlag,
            hireRestrictionFF,
            isNgoNotSelected,
            isAssociateAccountNotSelected,
            authorization,
            type
        } = this.props;

        const preLeaveModal = this.buildPreLeaveModal();

        const stepContent = cloneElement(
            children[currentStep],
            {
                onSetAsCurrentStep: this.handleSetAsCurrentStep,
                stepData: steps.get(currentStep)
            }
        );

        const wizardStepsClassName = classNames('ok-wizard__steps', {
            'row no-gutter clearfix ok-wizard__steps--full-width': fullWidth
        });

        const wizardContents = (
            <div className="ok-wizard">
                <section className="ok-wizard__header no-print-out">
                    <OKWizardProgressIndicator
                        currentStep={currentStep}
                        stepsAmount={this.props.children.length}
                        immSteps={steps}
                    />
                </section>
                <section className={wizardStepsClassName}>
                    {stepContent}
                </section>
                <div className="ok-wizard__footer">
                    <footer className="ok-wizard__footer-buttons">
                        {
                            false && <div className="ok-wizard__first-button">
                                <OKButton
                                    modifier="link-ghost"
                                    onClick={this.handleGoBack}
                                    loading={goBackButtonStatus.get('loading')}
                                    disabled={goBackButtonStatus.get('disabled')}
                                >
                                    <FormattedText
                                        value="buttonsActions-goBack"
                                        format="firstUppercase"
                                    />
                                </OKButton>
                            </div>
                        }
                        {
                            <div className="ok-wizard__first-button">
                                <OKButton
                                    modifier="link-ghost"
                                    onClick={this.handleCancel}
                                    loading={cancelButtonStatus.get('loading')}
                                    disabled={cancelButtonStatus.get('disabled')}
                                >
                                    <FormattedText
                                        value="buttonsActions-cancel"
                                        format="firstUppercase"
                                    />
                                </OKButton>
                            </div>
                        }
                        {
                            currentStep > 0 && <div className="ok-wizard__second-button">
                                <OKButton
                                    modifier="ghost"
                                    leftIcon="icon-anterior"
                                    onClick={this.handlePrevious}
                                    loading={previousButtonStatus.get('loading')}
                                    disabled={previousButtonStatus.get('disabled')}
                                >
                                    <FormattedText
                                        value="buttonsActions-previous"
                                        format="firstUppercase"
                                    />
                                </OKButton>
                            </div>
                        }
                        {
                            currentStep < (this.props.children.length - 1) && <div className="ok-wizard__third-button">
                                <OKButton
                                    modifier="secondary"
                                    rightIcon="icon-siguiente"
                                    onClick={this.handleNext}
                                    loading={
                                        currentStep === 0 && hireRestrictionFF ?
                                        validateLoadingFlag
                                        :
                                        nextButtonStatus.get('loading')}
                                        disabled={(__CONTACT_CENTER__ && !authorization && currentStep === 0) || (type === ONG && !authorization && currentStep === 0) || (currentStep === 1 && (isAssociateAccountNotSelected || isNgoNotSelected)) || nextButtonStatus.get('disabled')}
                                >
                                    <FormattedText
                                        value="buttonsActions-next"
                                        format="firstUppercase"
                                    />
                                </OKButton>
                            </div>
                        }
                        {
                            currentStep === (this.props.children.length - 1) && <div className="ok-wizard__fourth-button">
                                <OKButton
                                    modifier="secondary"
                                    onClick={this.handleSubmit}
                                    loading={submitButtonStatus.get('loading')}
                                    disabled={submitButtonStatus.get('disabled')}
                                >
                                    <FormattedText
                                        value="okWizard-submitButton"
                                        format="firstUppercase"
                                    />
                                </OKButton>
                            </div>
                        }
                    </footer>
                </div>
                {preLeaveModal}
            </div>
        );

        let content = (
            <Fragment>
                <div className="col-xs-12 col-md-8">{wizardContents}</div>
                <div className="col-xs-12 col-md-4">{wizardSideContent}</div>
            </Fragment>
        );

        if (!Boolean(wizardSideContent)) {
            content = (
                <Fragment>
                    <div className="col-xs-12">{wizardContents}</div>
                </Fragment>
            );
        }

        return content;
    }
}

OKWizard.propTypes = {
    children: PropTypes.any,
    fullWidth: PropTypes.bool,
    resetWizard: PropTypes.func,
    onConfirmLeave: PropTypes.func,
    processType: PropTypes.string,
    type: PropTypes.string,
    defaultRecordProcess: PropTypes.bool,
    //Preleave modal related propTypes.
    preleaveModalLeftButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool
    }),
    preleaveModalRightButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool
    }),
    onPreLeaveModalReady: PropTypes.func,
    preleaveModalMessage: PropTypes.string,
    preleaveModalTitle: PropTypes.string,
    tealium: PropTypes.object,
    // Wizard reducer.
    localSetCurrentStep: PropTypes.func.isRequired,
    validateLoading: PropTypes.func.isRequired,
    localAddStep: PropTypes.func.isRequired,
    localRemoveStep: PropTypes.func.isRequired,
    localResetData: PropTypes.func.isRequired,
    localValidateGDPRAndOrOTP: PropTypes.func.isRequired,
    localSetWizardSuccess: PropTypes.func.isRequired,
    localSetWizardError: PropTypes.func.isRequired,
    localSetWizardRestrictionError: PropTypes.func.isRequired, 
    hireRestrictionFF: PropTypes.bool,
    currentStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    wizardSideContent: PropTypes.object,
    submitResults: PropTypes.func.isRequired,
    setHireMessage: PropTypes.func.isRequired,
    otpError: PropTypes.bool.isRequired,
    nextButtonStatus: PropTypes.object.isRequired,
    goBackButtonStatus: PropTypes.object.isRequired,
    cancelButtonStatus: PropTypes.object.isRequired,
    previousButtonStatus: PropTypes.object.isRequired,
    submitButtonStatus: PropTypes.object.isRequired,
    localSetWizardButtonStateByButton: PropTypes.func.isRequired,
    goBackLink: PropTypes.string,
    history: PropTypes.object.isRequired,
    isNgoNotSelected: PropTypes.bool,
    isAssociateAccountNotSelected: PropTypes.bool,
    authorization: PropTypes.bool
};

OKWizard.defaultProps = {
    fullWidth: false,
    onPreLeaveModalReady: () => { return false },
    tealium: {},
    defaultRecordProcess: true,
    authorization: false
}

module.exports.OKWizard = connect(
    state => ({
        steps: state.okWizard.get('steps'),
        hireRestrictionFF: state.flagBasedFeatures.get(MESSAGE_HIRE_24H), 
        currentStep: state.okWizard.get('currentStep'),
        validateLoadingFlag: state.okWizard.get('validateLoadingFlag'),
        otpError: state.signaturePattern.get('isFetchingSMSCodeError'),
        goBackButtonStatus: state.okWizard.getIn(['buttons', 'goBack']),
        cancelButtonStatus: state.okWizard.getIn(['buttons', 'cancel']),
        previousButtonStatus: state.okWizard.getIn(['buttons', 'previous']),
        nextButtonStatus: state.okWizard.getIn(['buttons', 'next']),
        submitButtonStatus: state.okWizard.getIn(['buttons', 'submit']),
        isNgoNotSelected: state.okWizard.get('isNgoNotSelected'),
        isAssociateAccountNotSelected: state.okWizard.get('isAssociateAccountNotSelected'),
    }),
    {
        localAddStep: addStep,
        localRemoveStep: removeStep,
        localSetCurrentStep: setCurrentStep,
        validateLoading: validateLoading,
        localResetData: resetData,
        localSetWizardSuccess: setWizardSuccess,
        localSetWizardError: setWizardError,
        localSetWizardRestrictionError: setWizardRestrictionError,
        localValidateGDPRAndOrOTP: validateGDPRAndOrOTP,
        localSetWizardButtonStateByButton: setWizardButtonStateByButton,
        updateConsents: updateConsents
    }
)(withRouter(OKWizard));
